import React from 'react'
import Our from '../Error/Our/Our'

const Error = () => {
    return (
        <>
            <Our />
        </>
    )
}

export default Error